import { render, staticRenderFns } from "./Setup_Image.vue?vue&type=template&id=d57e598c&scoped=true&"
import script from "./Setup_Image.vue?vue&type=script&lang=js&"
export * from "./Setup_Image.vue?vue&type=script&lang=js&"
import style0 from "./Setup_Image.vue?vue&type=style&index=0&id=d57e598c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d57e598c",
  null
  
)

export default component.exports